import styled from 'styled-components';

import Select from 'components/lib/Select';

export const CreateEditActionPlansModalSelect = styled(Select)`
  &&& {
    width: 100%;

    .ant-select-selector {
      height: 36px;
      min-height: 36px;
      align-items: center;
    }

    .ant-select-selection-item {
      display: flex;
      align-items: center;
      height: 100%;
      line-height: normal;
      padding-inline-end: 0;
      min-width: 0;
      overflow: hidden;
    }

    .ant-select-selection-placeholder,
    .ant-select-selection-search-input {
      height: 34px;
      line-height: 34px;
    }
  }
`;

export const CreateEditActionPlansModalSelectLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const CreateEditActionPlansModalSelectOptionLabel = styled.span`
  display: flex;
  align-items: center;
  min-height: 100%;
  min-width: 0;
`;
